module.exports = __webpack_public_path__ + "img/scoreActive_02.3e81fabe.svg";